<template>
  <div>
    <div
      v-if="!MENU_LATERAL_ATIVO"
      class="position-absolute mt-1 ml-2 d-flex align-center z-999 cursor-pointer"
      @click="MENU_LATERAL_ATIVO = !MENU_LATERAL_ATIVO"
    >
      <v-icon :size="22">mdi-menu</v-icon>
      <span class="font-14 font-weight-medium text-gray-1100 pl-1">Abrir Detalhamento</span>
    </div>

    <div v-show="MENU_LATERAL_ATIVO" id="conteudo">
      <div class="d-flex align-center py-1 px-2">
        <span class="font-15 font-weight-medium">Detalhamento Sugestão de Compra</span>

        <v-spacer />

        <v-btn icon @click="MENU_LATERAL_ATIVO = !MENU_LATERAL_ATIVO">
          <v-icon :size="26">mdi-chevron-left</v-icon>
        </v-btn>
      </div>

      <div class="overflow-y-auto pb-10 pl-2 pr-1" style="height: calc(100vh - 105px)">
        <DetalhesProduto class="w-full" :dados="detalhamento" />

        <PedidosEmAberto
          v-if="detalhamento.pedidos_em_aberto.length > 0"
          class="mt-6"
          :pedidos_em_aberto="detalhamento.pedidos_em_aberto"
          :dados_conversao="{
            multiplo_compra: detalhamento.multiplo_compra,
            tipo_fator_conversao: detalhamento.tipo_fator_conversao
          }"
        />

        <EntradasFutura
          v-if="detalhamento.entradas_futuras.length > 0"
          class="mt-6"
          :entradas_futuras="detalhamento.entradas_futuras"
          :dados_conversao="{
            multiplo_compra: detalhamento.multiplo_compra,
            tipo_fator_conversao: detalhamento.tipo_fator_conversao
          }"
        />

        <AnaliseSugestao
          class="mt-6"
          :analise_entrada_sugestao="detalhamento.analise_entrada_sugestao"
          :dados_conversao="{
            multiplo_compra: detalhamento.multiplo_compra,
            tipo_fator_conversao: detalhamento.tipo_fator_conversao
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DetalhesProduto from "@/components/produto/Compras/DetalhamentoSugestao/Tabelas/DetalhesProduto.vue";
import PedidosEmAberto from "@/components/produto/Compras/DetalhamentoSugestao/Tabelas/PedidosEmAberto.vue";
import EntradasFutura from "@/components/produto/Compras/DetalhamentoSugestao/Tabelas/EntradasFutura.vue";
import {buscarDetalhamentoProduto} from "@/api/compraPorProdutosGerais/SugestaoCompra";
import {logout} from "@/helpers";
import AnaliseSugestao from "@/components/produto/Compras/DetalhamentoSugestao/Tabelas/AnaliseSugestao";

export default {
  name: "Tabela",
  components: {
    AnaliseSugestao,
    DetalhesProduto,
    PedidosEmAberto,
    EntradasFutura,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    idgrupo: Number,
    filial: Number,
    produtos: Array,
    idproduto: String,
    quantidade_compra: Number,
    card_completar_compra: Boolean,
  },
  emits: ['dadosConversao'],
  data: () => ({
    detalhamento: {
      estoque: 0,
      cobertura_estoque: 0,
      estoque_seguranca: 0,
      cobertura_estoque_seguranca: 0,
      ponto_pedido: 0,
      cobertura_ponto_pedido: 0,
      estoque_maximo: 0,
      cobertura_estoque_maximo: 0,
      consumo_medio_mensal: 0,
      tempo_medio_ressuprimento: 0,
      multiplo_compra: 0,
      pedidos_em_aberto: [],
      entradas_futuras: [],
      analise_entrada_sugestao: {}
    }
  }),
  computed: {
    MENU_LATERAL_ATIVO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        return this.$emit('update:modelValue', valor);
      }
    }
  },
  mounted() {
    this.buscarDetalhamentoProduto();
  },
  methods: {
    buscarDetalhamentoProduto() {
      const parametros = {
        id_grupo: this.idgrupo,
        filial: this.filial,
        produtos: this.produtos,
        idproduto: this.idproduto,
        quantidade_compra: this.quantidade_compra,
        card_completar_compra: this.card_completar_compra ? 'S' : 'N',
      };

      this.$store.dispatch("loading/addRequisicao",
        buscarDetalhamentoProduto(parametros)
          .then(detalhamento => {
            this.detalhamento = detalhamento;
            this.$emit('dadosConversao', detalhamento)
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
#conteudo {
  border-right: .1rem solid #c5c5c5;
  height: calc(100vh - 63px);
  box-shadow: 5px 10px 12px 0 #e3e3e3;
}
</style>
